import { useState } from 'react';
import type { SessionState } from '../lib/session.js';
import { emitirAccesoMeet, revocarAccesoMeet, type CredencialMeet } from '../lib/meet-conexion.js';

/** El secreto solo vive en el estado de esta pantalla hasta copiarlo o cerrarla. */
export function MeetConexion({ session }: { session: SessionState }) {
  const [credencial, setCredencial] = useState<CredencialMeet | null>(null);
  const [ocupado, setOcupado] = useState(false);
  const [mensaje, setMensaje] = useState('');
  if (session.client.slug !== 'fluxo') return null;
  async function generar() {
    setOcupado(true); setMensaje(''); setCredencial(null);
    try { setCredencial(await emitirAccesoMeet(session)); }
    catch (e) { setMensaje(e instanceof Error ? e.message : 'No se ha podido conectar Meet.'); }
    finally { setOcupado(false); }
  }
  async function copiar() {
    if (!credencial) return;
    try {
      await navigator.clipboard.writeText(credencial.token);
      setMensaje(`Credencial copiada. Pégala en Ajustes de Fluxo para Meet. Caduca el ${new Date(credencial.caducaEn).toLocaleDateString('es-ES')}.`);
      setCredencial(null);
    } catch { setMensaje('No se ha podido copiar. Selecciona la credencial y cópiala.'); }
  }
  async function revocar() {
    setOcupado(true); setCredencial(null); setMensaje('');
    try { await revocarAccesoMeet(session); setMensaje('Acceso revocado. La extensión ya no puede enviar ni consultar tus reuniones.'); }
    catch (e) { setMensaje(e instanceof Error ? e.message : 'No se ha podido revocar el acceso.'); }
    finally { setOcupado(false); }
  }
  return (
    <details className="meet-conexion" onToggle={(e) => { if (!e.currentTarget.open) setCredencial(null); }}>
      <summary>Conectar Meet</summary>
      <p>Instala Fluxo para Meet en Chrome y pega tu credencial en sus Ajustes. Este acceso solo sirve para tus grabaciones de la cuenta Fluxo.</p>
      <p>Caduca al año. Generar una nueva revoca la anterior para tu cuenta. Termina cualquier grabación antes de renovarla.</p>
      <div className="botones">
        <button type="button" disabled={ocupado} onClick={generar}>{ocupado ? 'Espera...' : 'Generar credencial'}</button>
        <button type="button" disabled={ocupado} onClick={revocar}>Revocar acceso</button>
      </div>
      {credencial && <div>
        <p>Se muestra una sola vez. Caduca el {new Date(credencial.caducaEn).toLocaleDateString('es-ES')}.</p>
        <label>Tu credencial <input aria-label="Tu credencial Meet" type="password" readOnly autoComplete="off" value={credencial.token} /></label>
        <button type="button" onClick={copiar}>Copiar credencial</button>
      </div>}
      {mensaje && <p role="status">{mensaje}</p>}
    </details>
  );
}
